const en = {
  message: {
    switchLang: "Select Language",
    home: "Home",
    about: "About Us",
    product: "Products",
    productTitle1: "Customized Design Services",
    productTitle2: "Products",
    news: "News",
    contact: "Contact",
    navigation: "Navigator",
    support: "Support",
    // placeholderInNav: "Enter keywords",

    name: "Wisdom Arrives Universe",
    slogan: "Beyond What's Possible",
    next: "Next Page",
    up: "Last Page",

    // info1: `"We are a leading provider of IoT and AI solutions."`,
    // info2:
    //   "We use the IoT as the base carrier, combining artificial intelligence algorithms and embedded system development closely with applications. On top of the basic IoT functions, we develop lightweight deep learning algorithms to achieve fast reasoning in the cloud and at the edge, which can be widely used in various intelligent applications, such as industrial IoT, medical and health, enterprise applications, wearable devices, etc. ",

    // whatWeDo1: `Full stack development capability from terminal hardware to Cloud and Mobile apps.`,
    // whatWeDo2: `Customised development for standard and corporate products.`,
    // whatWeDo3: `From circuit design, simulation, PCB Layout, structural design to production delivery and shipment.`,

    // productHead: `Our products `,

    // applicationScenarios: `Product application scenarios`,
  },
  contact: {
    email: "chinali80{'@'}163.com",
    title: `Contact`,
    Postcode: `518101`,
    phone: "13480945504",
    location: `542 A2, Huafeng Zhigu, Aviation Road, Sanwei Community, Hangcheng Street, Bao'an District, Shenzhen, China.`,
    wechat: `WeChat Public`,
    locationTitle: "Address",
    phoneTitle: "Phone",
    PostcodeTitle: "Postcode",
    emailTitle: "Email",
  },
  footer: {
    copyright: "Zhizhenhuanyu Hi-Tech (ShenZhen) Co., Ltd",
    version: "Version",
  },
  about: {
    jianjie: `About Us `,
    bigEventTitle: `Milestones`,
    info: `<p> Zhizhenhuanyu Hi-Tech (Shenzhen) Co., Ltd is a leading provider and customize developer of AIoT product. The company's wireless intelligent terminal products, cloud management platforms, and bespoke solutions—developed using 4G, LPWAN, BLE, WiFi and other communication protocols alongside edge computing and artificial intelligence algorithms—enable high-precision and high-speed data acquisition, accurate measurement, voice interaction, edge processing, edge-cloud collaboration, low power consumption, and operation in strong electromagnetic environments. Featuring waterproofing, salt spray resistance, and UV protection, these solutions find extensive application across diverse sectors including: smart power systems, construction sites, tower infrastructure, urban environments, agriculture, equipment cloud connectivity, and marine monitoring.</p>
    <p>The company possesses full-stack development capabilities spanning terminals, edge computing, cloud infrastructure, hardware, firmware, and software, offering standardised products, bespoke customisation, and tailored R&D services. Zhizhen Huanyu's products and technical solutions employ the industry's most advanced technologies while pursuing relentless innovation, striving to propel corporate development through proprietary core technologies.</p>
    <p>Zhizhenhuanyu maintains an exceptional supply chain, with core components sourced directly from industry-leading original manufacturers providing technical support. The company possesses end-to-end project delivery capabilities spanning the entire industrial chain, from R&D through to production.</p>
    `,
    bigEvent: `
    <p>Company Milestones:</p>
    <p>1、Exhibit at the 22nd China Hi-Tech Fair from Nov. 11 to 15, 2020.</p>
    <p>2、Exhibited at the 23rd China Hi-Tech Fair from Dec. 27th to 29th, 2021.</p>
    <p>3、On March 9, 2022, Wizhenhuangyu High-Tech (Shenzhen) Co., Ltd. won the tender project of intelligent equipment R&D service for a large domestic electric power enterprise.</p>
    <p>4、On November 15, 2022, we participated in the 24th China Hi-Tech Fair Munich South China Electronics Fair International Embedded System Innovation Forum and delivered a speech: "Smart IoT Solutions, Frontier Technologies and Future Development Trends".</p>`,
  },
  support: {
    title: "Support",
    title2: "Product Brochure",
    table: {
      title: "Title",
      version: "Version",
      publish_time: "Publish Time",
      download: "Download",
      name: "Zhizhenhuanyu Y2025 Product Brochure",
    },
  },
  news: {
    banner: {
      title: "Latest News",
      slogan: "Keep up to date with our latest news",
    },
    publish: "Published on",
  },
  home: {
    section1: {
      title: "Customized Design Services",
      item1: "Customized Electronic Product Design Services",
      item2: "Embedded Software Development",
      item3: "Customized Front-end Development",
      item4: "Mechanical Design",
    },
    section2: {
      title: "Products",
      item1: "Gateway Products",
      item2: "Terminal Products",
      item3: "Intelligent IOT Console System",
      item4: "Digital Skyworks-Smart Factory",
    },
    section3: {
      title: "Application Scenarios",
      item1: "Smart Grids",
      item2: "Smart Tower",
      item3: "Marine monitoring",
      item4: "Intelligent Healthcare",
      item5: "Intelligent Factory",
    },
  },
  navMenu: {
    support: {
      title: "Support",
      child: {
        title: "Download",
        child: {
          title: "Product Brochure",
        },
      },
    },
    serive: {
      title: "Customized Design Services",
      child1: {
        title: "Electronic Product Design Services",
        child: {
          title1: "Circuit Design",
          title2: "Embedded Software Development",
          title3: "Mechanical Design",
        },
      },
      child2: {
        title: "Application Development",
        child: {
          title1: "Desktop Application Development",
        },
      },
      child3: {
        title: "Customized Front-end Development",
        child: {
          title1: "Front-end Development",
        },
      },
      child4: {
        title: "Data Analysis",
      },
      child5: {
        title: "Edge Computing Gateway",
      },
    },
    product: {
      title: "Products",
      child1: {
        title: "EPT Series",
        child: {
          title1: "NB-IoT Terminal",
          title2: "LoRa Edge Gateway",
          title3: "Edge Processing Terminal",
          title4: "Edge Processing Terminal(small)",
          title5: "4G Voice Terminal Ⅰ",
          title6: "4G Voice Terminal Ⅱ",

          title7: "Electrical Parameter Monitoring Power Cord",
          title8: "TurMass™Terminal",
          title9: "TurMass™ Edge Gateway",
          title10: "LoRa Terminal",
          title11: "Terminals For Current Monitoring",
        },
      },
      child2: {
        title: "Cloud Software",
        child: {
          title1: "Intelligent IOT Console System",
        },
      },
      child3: {
        title: "Digtal Twins",
        child: {
          title1: "Digital Skyworks-Smart Factory",
        },
      },
      child4: {
        title: "Machine Vision",
        child: {
          title1: "Security Applications",
          title2: "Industrial Inspection",
        },
      },
    },
  },
  download: "Download literature",

  banner: {
    ele: {
      title: "One-Stop Customized Electronic Product Design Service(EDS)",
      desc: "Complete Product Design {'|'} Parts Design {'|'} Engineering Changes",
    },
    app: {
      title: "Application Development",
    },
    frontend: {
      title: "Front-end Development",
    },
    software: {
      title: "Cloud Software",
    },
    digtal: {
      title: "Digtal Twins",
    },
    hardware: {
      title: "EPT Series",
      core: {
        input: "input",
        size: "Module size",
        Core: "Core",
        FLASH: "FLASH",
        RAM: "RAM/SRAM",
        Fre: "Main Frequency(Max)",
      },
      netpune: {
        input: "Input Parameters",
        chip: "Module ",
        SRAM: "SRAM | ROM",
        FLASH: "SPI FLASH",
        device1: "Temperature and humidity sensor",
        device2: "Six-axis acceleration",
      },
      fourG: {
        input: "Power Supply",
        size: "Size",
        RAM: "RAM",
        ROM: "ROM",
        file: "File system",
      },
      nbiot: {
        input: "Power Supply",
        fre: "Frequency band",
        size: "Size",
        core: "Core",
        flash: "FLASH",
        RAM: "RAM | SRAM",
        max: "Max Frequency",
        eeprom: "EEPROM",
      },
      lora: {
        input: "Power Supply",
        size: "Size",
        core: "Core",
        flash: "FLASH",
        RAM: "RAM | SRAM",
        max: "Max Frequency",
        eeprom: "EEPROM",
      },
      gateway: {
        flash: "FLASH",
        fre: "LoRa frequency",
      },
    },
    vision: {
      title: "Machine Vision",
    },
    data: {
      title: "Data Analysis",
    },
  },
  linkTab: {
    ele: {
      title: "Electronic Product Design Services",
    },
  },
  input: "power supply",
  size: "size",
  download: "download",
  fre: "frequency",
  core: "core",
  netrate: "Ethernet speed",
  rate: "Transmission rate",
  distance: "Communication distance",
  fre_lora: "LoRa Frequency band",
  fre_4g: "4G Frequency band",
  rate_4g: "4G rate",
  LoRa_Receive_Sensitivity: "LoRa_Receive_Sensitivity",
  max_freq: "Main Frequency",
  type: "shell",
};

export default en;
